import { render } from "./PriorApprovalAttestation.vue?vue&type=template&id=3ab69779&scoped=true"
import script from "./PriorApprovalAttestation.vue?vue&type=script&lang=js"
export * from "./PriorApprovalAttestation.vue?vue&type=script&lang=js"

import "./PriorApprovalAttestation.vue?vue&type=style&index=0&id=3ab69779&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab69779"]])

export default __exports__